<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";

export default {
  mixins: [planSetter],
  props: {
    planId: String,
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    eligibleMonthItems() {
      return [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ];
    },
    waiverStatusItems() {
      return [
        { text: "Initial", value: 0 },
        { text: "Update", value: 1 },
        { text: "Cancel", value: 2 },
      ];
    },
    defaultWaiverStatusItems() {
      return [
        { text: "Initial", value: "OptOutInitialWaiver" },
        { text: "Update", value: "OptOutEditWaiver" },
        { text: "Cancel", value: "OptOutDeleteWaiver" },
      ];
    },
    statusTemplateItems() {
      return [
        { text: "Received", value: "Received" },
        { text: "Pending", value: "Pending" },
        { text: "Rejected", value: "Rejected" },
        { text: "TentativelyApproved", value: "TentativelyApproved" },
        { text: "Approved", value: "Approved" },
        { text: "Updated", value: "Updated" },
        { text: "Cancelled", value: "Cancelled" },
        { text: "Paid", value: "Paid" },
      ];
    },
    coverageItems() {
      return this.coverages.map((x) => ({
        text: x.description,
        value: x.id,
      }));
    },
  },
  data() {
    return {
      showRemoveConfirmationDialog: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      selectedPeriodId: null,
      menuOpen: false,
      selectedEmailStatus: null,
      emailTemplate: {
        selectedStatus: null,
        subject: "",
        template: "",
      },
      emailTemplates: [],
      settings: {
        waiverType: null,
        waiverText: "",
        defaultWaiverType: null,
        optOutInitialWaiver: "",
        optOutEditWaiver: "",
        optOutDeleteWaiver: "",
        adminEmail: "",
        hasReimbursements: false,
        approvalPercentage: 0,
      }, //add optOutConfiguration
      coverages: [],
      memberGroups: [],
      coverageGroups: [],
      period: {
        waiverStatus: null,
        waiverText: "",
        name: "",
        optOutStart: null,
        optOutEnd: null,
        optOutEffectiveDate: null,
        eligibleMonths: [],
        coverageGroups: [],
        customWaiverTexts: [
          { textType: 0, waiverText: "" },
          { textType: 1, waiverText: "" },
          { textType: 2, waiverText: "" },
        ],
      }, // add period
      coverageGroup: {}, // add coverageGroup
      memberGroup: {},
      periods: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction
            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions("optouts", [
      "loadConfiguration",
      "loadCoverageGroups",
      "loadPeriods",
      "addPeriod",
      "updatePeriod",
      "removePeriod",
      "loadCoverages",
      "loadMemberGroups",
      "saveConfiguration",
      "editConfiguration",
      "addCoverageGroup",
      "updateCoverageGroup",
      "removeCoverageGroup",
      "getEmailTemplate",
      "updateEmailTemplate",
    ]),
    showSnackbar(color, message) {
      this.snackbar.show = true;
      this.snackbar.color = color;
      this.snackbar.message = message;
    },
    async load() {
      if (!this.selectedPlan?.Id) return;
      this.loadConfiguration(this.selectedPlan.Id).then((settings) => {
        this.settings = {
          ...settings,
          optOutInitialWaiver: settings.optOutInitialWaiver || "",
          optOutEditWaiver: settings.optOutEditWaiver || "",
          optOutDeleteWaiver: settings.optOutDeleteWaiver || "",
        };

        if (this.settings.defaultWaiverType) {
          this.updateWaiverTextFromType(this.settings.defaultWaiverType);
        }
      });
      this.emailTemplates = [];
      await this.loadEmailTemplates();
      this.loadPeriods(this.selectedPlan.Id).then((periods) => {
        this.periods = periods.map((p) => ({
          ...p,
          customWaiverTexts: this.waiverStatusItems.map((item) => {
            const existing = p.customWaiverTexts.find(
              (x) =>
                x.textType === item.value ||
                x.textType?.toString() === item.text
            );
            return {
              textType: item.value,
              waiverText: existing?.waiverText || "",
              id: existing?.id,
            };
          }),
        }));
      });
      this.loadCoverages(this.selectedPlan.Id).then((coverages) => {
        this.coverages = coverages;
      });
      this.loadMemberGroups(this.selectedPlan.Id).then((memberGroups) => {
        this.memberGroups = memberGroups;
      });
      this.loadCoverageGroups(this.selectedPlan.Id).then((groups) => {
        this.coverageGroups = groups;
      });
    },
    async loadEmailTemplates() {
      if (!this.selectedPlan?.Id) return;
      const statuses = this.statusTemplateItems.map((item) => item.value);
      const tempaltes = [];
      statuses.forEach(async (status) => {
        const response = await this.getEmailTemplate({
          planId: this.selectedPlan.Id,
          status: status,
        });
        tempaltes.push(response);
      });
      this.emailTemplates = tempaltes;
    },
    async onStatusTemplateChange(newStatus) {
      const selectedTemplate = this.emailTemplates.find(
        (t) => t.emailStatus === newStatus
      );
      if (selectedTemplate) {
        this.emailTemplate = {
          selectedStatus: newStatus,
          subject: selectedTemplate.subject,
          template: selectedTemplate.template,
        };
      } else {
        this.emailTemplate = {
          selectedStatus: newStatus,
          subject: "",
          template: "",
        };
      }
    },
    async saveEmailTemplate() {
      const payload = {
        PlanId: this.selectedPlan.Id,
        OptOutStatus: this.emailTemplate.selectedStatus,
        Subject: this.emailTemplate.subject,
        Template: this.emailTemplate.template,
      };
      console.log("Saving email template:", payload);
      await this.updateEmailTemplate(payload);
      this.showSnackbar("success", "Email template successfully updated");
      this.load();

      const index = this.settings.emailTemplates.findIndex(
        (t) => t.emailStatus === this.emailTemplate.selectedStatus
      );

      if (index !== -1) {
        this.settings.emailTemplates[index] = {
          ...this.settings.emailTemplates[index],
          subject: this.emailTemplate.subject,
          template: this.emailTemplate.template,
        };
      }
    },
    async save() {
      if (this.settings.defaultWaiverType && this.settings.waiverText) {
        this.saveWaiverTextToType(
          this.settings.defaultWaiverType,
          this.settings.waiverText
        );
      }

      const data = {
        planId: this.selectedPlan.Id,
        adminEmail: this.settings.adminEmail,
        optOutInitialWaiver: this.settings.optOutInitialWaiver,
        optOutEditWaiver: this.settings.optOutEditWaiver,
        optOutDeleteWaiver: this.settings.optOutDeleteWaiver,
        hasReimbursements: this.settings.hasReimbursements,
        approvalPercentage: this.settings.approvalPercentage,
      };

      console.log("Saving opt-out settings:", data);
      await this.saveConfiguration(data);
      this.showSnackbar("success", "Opt-out configuration successfully saved");
    },
    async addOptOutPeriod() {
      if (this.period.waiverStatus !== null) {
        const existing = this.period.customWaiverTexts.find(
          (x) => x.textType === this.period.waiverStatus
        );
        if (existing) {
          existing.waiverText = this.period.waiverText;
        } else {
          this.period.customWaiverTexts.push({
            textType: this.period.waiverStatus,
            waiverText: this.period.waiverText,
          });
        }
      }

      await this.addPeriod({ planId: this.planId, period: this.period });

      this.period = {
        waiverStatus: null,
        waiverText: "",
        name: "",
        optOutStart: null,
        optOutEnd: null,
        optOutEffectiveDate: null,
        eligibleMonths: [],
        coverageGroups: [],
        customWaiverTexts: [],
      };

      this.showSnackbar("success", "Opt-out period successfully added");
      this.periods = await this.loadPeriods(this.planId);
    },
    async updateOptOutPeriod(period) {
      const currentWaiverStatus = period.waiverStatus;

      const data = {
        ...period,
        coverageGroups: period.coverageGroups.map((x) => x.id),
        customWaiverTexts: period.customWaiverTexts.map((t) => ({
          id: t.id,
          textType: t.textType,
          waiverText: t.waiverText,
        })),
      };

      await this.updatePeriod({ planId: this.planId, period: data });

      const updatedPeriods = await this.loadPeriods(this.planId);
      this.periods = updatedPeriods.map((p) => ({
        ...p,
        customWaiverTexts: this.waiverStatusItems.map((item) => {
          const existing = p.customWaiverTexts.find(
            (x) =>
              x.textType === item.value || x.textType?.toString() === item.text
          );
          return {
            textType: item.value,
            waiverText: existing?.waiverText || "",
            id: existing?.id,
          };
        }),
        waiverStatus: p.id === period.id ? currentWaiverStatus : p.waiverStatus,
      }));

      this.showSnackbar("success", "Opt-out period successfully saved");
    },
    async removeOptOutPeriod(id) {
      this.showRemoveConfirmationDialog = true;
      this.selectedPeriodId = id;
    },
    async handleAccept() {
      if (this.selectedPeriodId) {
        await this.removePeriod({
          planId: this.planId,
          periodId: this.selectedPeriodId,
        });
        this.showSnackbar("success", "Opt-out period successfully removed");
        this.periods = await this.loadPeriods(this.planId);
      }
      this.showRemoveConfirmationDialog = false;
      this.selectedPeriodId = null;
    },
    handleWaiverTypeChange(p, newWaiverStatus) {
      p.waiverStatus = newWaiverStatus;
    },
    handlerDefaultWaiverTypeChange(settings, newWaiverStatus) {
      settings.defaultWaiverType = newWaiverStatus;

      console.log(
        "Default Waiver Type changed to:",
        newWaiverStatus,
        "with text:",
        settings.waiverText
      );
      console.log("Settings after change:", this.settings);
    },
    updateWaiverTextFromType(textType) {
      switch (textType) {
        case "OptOutInitialWaiver":
          this.settings.waiverText = this.settings.optOutInitialWaiver;
          break;
        case "OptOutEditWaiver":
          this.settings.waiverText = this.settings.optOutEditWaiver;
          break;
        case "OptOutDeleteWaiver":
          this.settings.waiverText = this.settings.optOutDeleteWaiver;
          break;
        default:
          this.settings.waiverText = "";
      }
    },
    saveWaiverTextToType(textType, text) {
      switch (textType) {
        case "OptOutInitialWaiver":
          this.settings.optOutInitialWaiver = text;
          break;
        case "OptOutEditWaiver":
          this.settings.optOutEditWaiver = text;
          break;
        case "OptOutDeleteWaiver":
          this.settings.optOutDeleteWaiver = text;
          break;
      }
    },
    handleCancel() {
      this.showRemoveConfirmationDialog = false;
      this.selectedPeriodId = null;
    },
    async addOptOutCoverageGroup() {
      const data = { ...this.coverageGroup };
      data.coverages = this.coverageGroup.coverages.map((g) => g.id);
      data.memberGroups = this.coverageGroup.memberGroups.map((m) => m.id);
      await this.addCoverageGroup({
        planId: this.planId,
        coverageGroup: data,
      });

      this.coverageGroup = {};
      this.showSnackbar("success", "Opt-out coverage group successfully added");
      this.coverageGroups = await this.loadCoverageGroups(this.planId);
    },
    async updateOptOutCoverageGroup(group) {
      const data = { ...group };
      data.coverages = group.coverages.map((g) => g.id);
      data.memberGroups = group.memberGroups.map((m) => m.id);

      await this.updateCoverageGroup({
        planId: this.planId,
        coverageGroup: data,
      });

      this.showSnackbar(
        "success",
        "Opt-out coverage group successfully updated"
      );
      this.coverageGroups = await this.loadCoverageGroups(this.planId);
    },
    async removeOptOutCoverageGroup(id) {
      await this.removeCoverageGroup({
        planId: this.planId,
        id: id,
      });

      this.showSnackbar(
        "success",
        "Opt-out coverage group successfully removed"
      );
      this.coverageGroups = await this.loadCoverageGroups(this.planId);
    },
  },
  mounted() {
    if (this.selectedPlan?.Id) {
      this.load();
    }
  },
  watch: {
    selectedPlan: {
      deep: true,
      immediate: true,
      handler(newPlan) {
        if (newPlan?.Id) {
          this.$nextTick(() => this.load());
        }
      },
    },
    "period.waiverStatus"(newVal, previousVal) {
      if (previousVal !== null) {
        const previousText = this.period.customWaiverTexts.find(
          (x) => x.textType === previousVal
        );
        if (previousText) {
          previousText.waiverText = this.period.waiverText;
        }
      }

      const newText = this.period.customWaiverTexts.find(
        (x) => x.textType === newVal
      );
      this.period.waiverText = newText ? newText.waiverText : "";
    },
    "settings.defaultWaiverType"(newVal, previousVal) {
      if (previousVal && this.settings.waiverText) {
        this.saveWaiverTextToType(previousVal, this.settings.waiverText);
      }

      this.updateWaiverTextFromType(newVal);
    },
  },
};
</script>

<template>
  <div v-if="selectedPlan">
    <material-card title="OptOut Settings" icon="mdi-cog">
      <v-card-text>
        <h2 class="mb-5">Configuration</h2>
        <v-text-field
          label="Admin Email"
          v-model="settings.adminEmail"
        ></v-text-field>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="defaultWaiverStatusItems"
              label="Waiver Text Type"
              v-model="settings.defaultWaiverType"
              @change="
                (newVal) => handlerDefaultWaiverTypeChange(settings, newVal)
              "
              style="max-width: 250px; min-width: 120px"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <quill-editor
              :key="`default-waiver-editor-${settings.id}-${settings.defaultWaiverType}`"
              v-model="settings.waiverText"
              :options="editorOption"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="statusTemplateItems"
              label="Opt-Out Email Template"
              v-model="emailTemplate.selectedStatus"
              @change="onStatusTemplateChange"
              item-text="text"
              item-value="value"
              style="max-width: 250px; min-width: 120px"
            />
          </v-col>
        </v-row>
        <v-row v-if="emailTemplate.selectedStatus !== null">
          <v-col cols="12">
            <v-text-field
              label="Email Subject"
              v-model="emailTemplate.subject"
              :value="emailTemplate.subject"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="d-flex align-center mb-2">
              <v-menu v-model="menuOpen">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn
                    v-bind="menuProps"
                    color="primary"
                    small
                    class="mr-2"
                    @click="menuOpen = !menuOpen"
                  >
                    Available Variables
                  </v-btn>
                </template>
                <v-card min-width="300">
                  <v-card-title class="bg-primary text-white">
                    Available Variables:
                  </v-card-title>
                  <v-card-text>
                    <ul>
                      <li>
                        <code v-pre>{{ FirstName }}</code>
                      </li>
                      <li>
                        <code v-pre>{{ LastName }}</code>
                      </li>
                      <li>
                        <code v-pre>{{ SubmissionId }}</code>
                      </li>
                      <li>
                        <code v-pre>{{ PeriodName }}</code>
                      </li>
                      <li>
                        <code v-pre>{{ CoverageGroupNames }}</code>
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-menu>
              <span class="text-caption"
                >Click to see the variables available within the Email
                template</span
              >
            </div>
            <quill-editor
              v-model="emailTemplate.template"
              :options="editorOption"
            />
          </v-col>
          <v-col>
            <v-btn color="primary" @click="saveEmailTemplate"
              >Save Template</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              label="Enable Reimbursements"
              v-model="settings.hasReimbursements"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-btn class="mt-5" color="primary" @click="save"
          >Save Configuration</v-btn
        >
        <v-divider class="my-5" />
        <h2 class="mb-5">Coverage Groups</h2>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header
              >New Coverage Group</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-row>
                <v-col>
                  <v-text-field
                    class="required"
                    :rules="[$rules.required]"
                    label="Name"
                    v-model="coverageGroup.name"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Description"
                    v-model="coverageGroup.description"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="coverages"
                    label="Coverages"
                    v-model="coverageGroup.coverages"
                    return-object
                    item-text="description"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="memberGroups"
                    label="Member Groups"
                    v-model="coverageGroup.memberGroups"
                    return-object
                    item-text="name"
                  />
                </v-col>
                <v-col>
                  <v-currency-field
                    v-if="settings.hasReimbursements"
                    label="Charge Amount"
                    v-model="coverageGroup.chargeAmount"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    id="isProofRequired"
                    v-model="coverageGroup.isProofRequired"
                    label="Is proof required?"
                    color="primary"
                    class="mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Auto Approval Percentage"
                    v-model.number="coverageGroup.approvalPercentage"
                    type="number"
                    min="0"
                    max="100"
                    append-icon="mdi-percent"
                    style="max-width: 250px; min-width: 120px"
                  />
                </v-col>
              </v-row>
              <v-btn
                class="ml-auto my-5"
                color="primary"
                @click="addOptOutCoverageGroup"
                >Add Coverage Group</v-btn
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="coverageGroup in coverageGroups"
            :key="coverageGroup.id"
          >
            <v-expansion-panel-header>{{
              coverageGroup.name
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col>
                  <v-text-field
                    :rules="[$rules.required]"
                    label="Name"
                    v-model="coverageGroup.name"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Description"
                    v-model="coverageGroup.description"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="coverages"
                    label="Coverages"
                    v-model="coverageGroup.coverages"
                    return-object
                    item-text="description"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="memberGroups"
                    label="Member Groups"
                    v-model="coverageGroup.memberGroups"
                    return-object
                    item-text="name"
                  />
                </v-col>
                <v-col>
                  <v-currency-field
                    v-if="settings.hasReimbursements"
                    label="Charge Amount"
                    v-model="coverageGroup.chargeAmount"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    id="isProofRequired"
                    v-model="coverageGroup.isProofRequired"
                    label="Is proof required?"
                    color="primary"
                    class="mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Auto Approval Percentage"
                    v-model.number="coverageGroup.approvalPercentage"
                    type="number"
                    min="0"
                    max="100"
                    append-icon="mdi-percent"
                    style="max-width: 250px; min-width: 120px"
                  />
                </v-col>
              </v-row>
              <v-btn text @click="updateOptOutCoverageGroup(coverageGroup)"
                >Save</v-btn
              >
              <v-btn
                text
                color="error"
                @click="removeOptOutCoverageGroup(coverageGroup.id)"
                >Remove</v-btn
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-divider class="my-5" />
        <h2 class="mb-5">Opt-Out Periods</h2>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>New Period</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Period Name"
                    :value="period.name"
                    v-model="period.name"
                    required
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <pbas-date-picker
                    label="Period start date"
                    :value="period.optOutStart"
                    @update-date="period.optOutStart = $event"
                    required
                    class="required"
                  />
                </v-col>
                <v-col>
                  <pbas-date-picker
                    label="Period end date"
                    :value="period.optOutEnd"
                    @update-date="period.optOutEnd = $event"
                    required
                    class="required"
                  />
                </v-col>
                <v-col>
                  <pbas-date-picker
                    label="Period effective date"
                    :value="period.optOutEffectiveDate"
                    @update-date="period.optOutEffectiveDate = $event"
                    required
                    class="required"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="eligibleMonthItems"
                    label="Eligible Months"
                    v-model="period.eligibleMonths"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="coverageGroups"
                    label="Coverage Groups"
                    v-model="period.coverageGroups"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    :items="waiverStatusItems"
                    label="Waiver Type (Status)"
                    v-model="period.waiverStatus"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Custom Waiver Text</p>
                  <quill-editor
                    :key="`waiver-editor-${period.waiverStatus}`"
                    v-model="period.waiverText"
                    :options="editorOption"
                  />
                </v-col>
              </v-row>
              <v-btn class="my-5" color="primary" @click="addOptOutPeriod"
                >Add Period</v-btn
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-for="p in periods" :key="p.id">
            <v-expansion-panel-header
              >{{ $helpers.formatDate(p.optOutStart) }} -
              {{ $helpers.formatDate(p.optOutEnd) }} - {{ p.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Period Name"
                    :value="p.name"
                    v-model="p.name"
                    required
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <pbas-date-picker
                    label="Period start date"
                    :value="p.optOutStart"
                    @update-date="p.optOutStart = $event"
                    required
                    class="required"
                  />
                </v-col>
                <v-col>
                  <pbas-date-picker
                    label="Period end date"
                    :value="p.optOutEnd"
                    @update-date="p.optOutEnd = $event"
                    required
                    class="required"
                  />
                </v-col>
                <v-col>
                  <pbas-date-picker
                    label="Period effective date"
                    :value="p.optOutEffectiveDate"
                    @update-date="p.optOutEffectiveDate = $event"
                    required
                    class="required"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="eligibleMonthItems"
                    label="Eligible Months"
                    v-model="p.eligibleMonths"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    multiple
                    :items="coverageGroups"
                    label="Coverage Groups"
                    v-model="p.coverageGroups"
                    item-text="name"
                    item-value="id"
                    return-object
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    :items="waiverStatusItems"
                    label="Waiver Type (Status)"
                    v-model="p.waiverStatus"
                    @change="(newVal) => handleWaiverTypeChange(p, newVal)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Custom Waiver Text</p>
                  <quill-editor
                    :key="`waiver-editor-${p.id}-${p.waiverStatus}`"
                    v-model="
                      (
                        p.customWaiverTexts.find(
                          (t) => t.textType === p.waiverStatus
                        ) || {}
                      ).waiverText
                    "
                    :options="editorOption"
                  />
                </v-col>
              </v-row>
              <v-btn text @click="updateOptOutPeriod(p)">Save</v-btn>
              <v-btn text color="error" @click="removeOptOutPeriod(p.id)"
                >Remove</v-btn
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog
          v-model="showRemoveConfirmationDialog"
          persistent
          max-width="500"
        >
          <v-card>
            <v-card-title class="primary white--text">
              {{ $t("globals.warning") }}
            </v-card-title>
            <v-card-text class="pt-4">
              {{ $t("components.opt_outs.period_remove_confirmation") }}
            </v-card-text>
            <v-card-actions class="pa-4 justify-end">
              <v-btn @click="handleCancel">{{ $t("globals.cancel") }}</v-btn>
              <v-btn color="primary" @click="handleAccept">{{
                $t("Accept")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="2000"
        >
          {{ $t(snackbar.message) }}
          <v-btn dark text @click="snackbar.show = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-snackbar>
      </v-card-text>
    </material-card>
  </div>
  <v-row v-else justify="center" class="mt-10">
    <v-progress-circular interminate color="primary" :size="70" :width="7" />
  </v-row>
</template>
